import styled from 'styled-components'

const StyledList = styled.ul`
  padding: 0px 0px 0px 19px;
  margin: 0;
`
export const AdsPlacementsRadioItemList: React.FC = () => (
  <StyledList>
    <li>Feeds</li>
    <li>Reels</li>
    <li>Stories</li>
  </StyledList>
)
